import React from 'react'
import { Form } from 'semantic-ui-react'

export default class AbaNameField extends React.PureComponent {
  render() {
    const { value, onChange, number } = this.props

    return (
      <Form.Input
        fluid
        label='ABA Name'
        placeholder="e.g Muuve Driver"
        onChange={e => onChange('aba', { name: e.target.value, number })}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/abaNameField.js